// using same in blog and widgets to reuse code
export const IS_VIEW_COUNT_ENABLED = 'blog-isViewCountEnabled';
export const IS_VIEW_COUNT_ENABLED_PATH = `style.booleans.${IS_VIEW_COUNT_ENABLED}`;

// Widget settings
export const WIDGET_BACKGROUND_COLOR = 'widget-backgroundColor';
export const WIDGET_BACKGROUND_COLOR_PATH = `style.colors.${WIDGET_BACKGROUND_COLOR}`;

export const WIDGET_CATEGORY_ID = 'widget-categoryId';
export const WIDGET_CATEGORY_ID_PATH = `custom.${WIDGET_CATEGORY_ID}`;

export const WIDGET_IS_FEATURED_POST = 'widget-isCustomFeedFeaturedPost';
export const WIDGET_IS_FEATURED_POST_PATH = `style.booleans.${WIDGET_IS_FEATURED_POST}`;

// List settings
export const LIST_POST_LIMIT_TYPE = 'list-postLimitType';
export const LIST_POST_LIMIT_TYPE_PATH = `style.numbers.${LIST_POST_LIMIT_TYPE}`;
export const LIST_POST_LIMIT_TYPE_NONE = 0;
export const LIST_POST_LIMIT_TYPE_LIMITED = 1;

export const LIST_NUMBER_OF_ROWS = 'list-numberOfRows';
export const LIST_NUMBER_OF_ROWS_PATH = `style.numbers.${LIST_NUMBER_OF_ROWS}`;

export const LIST_MASONRY_NUMBER_OF_POSTS = 'list-masonryNumberOfPosts';
export const LIST_MASONRY_NUMBER_OF_POSTS_PATH = `style.numbers.${LIST_MASONRY_NUMBER_OF_POSTS}`;

export const LIST_NUMBER_OF_POSTS = 'list-numberOfPosts';
export const LIST_NUMBER_OF_POSTS_PATH = `style.numbers.${LIST_NUMBER_OF_POSTS}`;

export const LIST_LAYOUT_ID = 'list-layoutId';
export const LIST_LAYOUT_ID_PATH = `style.numbers.${LIST_LAYOUT_ID}`;

// Post design params
export const POST_TITLE_FONT = 'post-titleFont';
export const POST_TITLE_COLOR = 'post-titleColor';

export const POST_TITLE_FONT_STANDARD = 'post-titleFont-standard';
export const POST_TITLE_COLOR_STANDARD = 'post-titleColor-standard';

export const POST_TITLE_FONT_TEXT_ON_IMAGE = 'post-titleFont-textOnImage';
export const POST_TITLE_COLOR_TEXT_ON_IMAGE = 'post-titleColo-textOnImager';

export const POST_DESCRIPTION_FONT = 'post-descriptionFont';
export const POST_DESCRIPTION_COLOR = 'post-descriptionColor';

export const POST_DESCRIPTION_FONT_STANDARD = 'post-descriptionFont-standard';
export const POST_DESCRIPTION_COLOR_STANDARD = 'post-descriptionColor-standard';

export const POST_DESCRIPTION_FONT_TEXT_ON_IMAGE = 'post-descriptionFont-textOnImage';
export const POST_DESCRIPTION_COLOR_TEXT_ON_IMAGE = 'post-descriptionColo-textOnImager';

// for text on image layouts only
export const POST_IMAGE_OVERLAY_COLOR = 'post-imageOverlayColor';

export const POST_HOVER_COLOR = 'post-hoverColor';
export const POST_HOVER_COLOR_STANDARD = 'post-hoverColor-standard';

export const POST_BACKGROUND_COLOR = 'post-backgroundColor';
export const POST_BACKGROUND_COLOR_PATH = `style.colors.${POST_BACKGROUND_COLOR}`;

export const POST_BORDER_COLOR = 'post-borderColor';
export const POST_BORDER_COLOR_PATH = `style.colors.${POST_BORDER_COLOR}`;

export const POST_BORDER_WIDTH = 'post-borderWidth';
export const POST_BORDER_WIDTH_PATH = `style.numbers.${POST_BORDER_WIDTH}`;
